import { render, staticRenderFns } from "./driving-licence.vue?vue&type=template&id=799cc0d0"
import script from "./driving-licence.vue?vue&type=script&lang=js"
export * from "./driving-licence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports